import { appConfig, geoData, targetEnv } from '@fs/zion-config'

let locations

// For performance, keep a small list of valid locations to validate config versus full supportedCallingLocations from @fs/zion-phone-number
const validLocations = ['BR', 'CA', 'US']

export default {
  get supportedLocations() {
    if (locations) {
      return locations
    }
    if (['local', 'int'].includes(targetEnv) && new URLSearchParams(window.location.search).get('noSms') === 'true') {
      locations = []
      return locations
    }
    locations =
      appConfig?.SMS_LOCATIONS?.trim()
        ?.split(',')
        ?.filter((x) => validLocations.includes(x)) || []
    return locations
  },
  get userLocationSupported() {
    const userLocation = targetEnv === 'local' ? 'US' : geoData?.country
    return this.supportedLocations.includes(userLocation)
  },
}
